import type { IFaqTabId } from '../constants';

import { FAQ_DEFAULT_TAB } from '../constants';
import { create } from 'zustand';

interface IFaqState {
  isOpen: boolean;
  activeTab: IFaqTabId;
}

interface IFaqActions {
  /** Open the modal. Pass a tab to jump straight to it (analytics entries → Data accuracy). */
  open: (params?: { tab?: IFaqTabId }) => void;
  close: () => void;
  setActiveTab: (tab: IFaqTabId) => void;
  reset: () => void;
}

interface IFaqStore extends IFaqState, IFaqActions {}

const DEFAULT_STATE: IFaqState = {
  isOpen: false,
  activeTab: FAQ_DEFAULT_TAB,
};

export const useFaqStore = create<IFaqStore>()((set) => ({
  ...DEFAULT_STATE,
  open: (params) => set({ isOpen: true, activeTab: params?.tab ?? FAQ_DEFAULT_TAB }),
  close: () => set({ isOpen: false }),
  setActiveTab: (tab) => set({ activeTab: tab }),
  reset: () => set(DEFAULT_STATE),
}));
